import { render, staticRenderFns } from "./insertOrganizationTicket.vue?vue&type=template&id=d07bf36c&"
import script from "./insertOrganizationTicket.vue?vue&type=script&lang=js&"
export * from "./insertOrganizationTicket.vue?vue&type=script&lang=js&"
import style0 from "./insertOrganizationTicket.vue?vue&type=style&index=0&id=d07bf36c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports